// src/routes/ProtectedRoute.jsx
import { isAuthenticated } from "../utils/auth";
const clientUrl = process.env.REACT_APP_CLIENT_URL || "http://localhost:3001";
const ProtectedRoute = ({ children }) => {
  if (!isAuthenticated()) {
    // 👇 Redirect ra trang client login (frontend public site)
    window.location.href = `${clientUrl}/login-register`;
    return null;
  }
  return children;
};

export default ProtectedRoute;
